// ** Stored as `provider|state` when the login starts
export const getOAuthState = (): string =>
    (
        localStorage.getItem(process.env.REACT_APP_OAUTH_STATE as string) || ''
    ).split('|')[1] || '';
